import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { AhaIcon, AhaSearchResultIcon } from './icon';

export const ahaConfig: ThirdPartyConfig = {
	displayName: 'Aha',
	id: 'aha',
	resourceType: ProductResourceTypes3P.Aha,
	icon: get3PLogo(AhaIcon, 'Aha', 'medium'),
	searchResultIcon: get3PLogo(AhaSearchResultIcon, 'Aha', 'large'),
	integrationAri: 'ari:cloud:platform::integration/aha',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
